import { render } from "./categorias-gastos.vue?vue&type=template&id=a80e3648&scoped=true"
import script from "./categorias-gastos.vue?vue&type=script&lang=js"
export * from "./categorias-gastos.vue?vue&type=script&lang=js"

import "./categorias-gastos.vue?vue&type=style&index=0&id=a80e3648&scoped=true&lang=css"
import "./categorias-gastos.vue?vue&type=style&index=1&id=a80e3648&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a80e3648"]])

export default __exports__